import { render, staticRenderFns } from "./flats-crm-filter.vue?vue&type=template&id=510ca71f"
import script from "./flats-crm-filter.vue?vue&type=script&lang=js"
export * from "./flats-crm-filter.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-filter.vue?vue&type=style&index=0&id=510ca71f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports